var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseExportContact",
    { attrs: { showSelectBuilding: false, postFixer: "worker-info" } },
    [
      _c(
        "HKLForm",
        {
          ref: "formRef",
          staticClass: "export-worker-search",
          attrs: { slot: "addtional-content" },
          slot: "addtional-content",
        },
        [
          _c(
            "div",
            { staticClass: "issue-date-range" },
            [
              _c(
                "label",
                { staticClass: "emphasis ad-search-condition-label" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("project.building")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("HKLMultiSelect", {
                staticClass: "check-valid building-option",
                attrs: {
                  required: true,
                  showTip: false,
                  options: _vm.buildingOptions,
                },
                model: {
                  value: _vm.selectedBuildings,
                  callback: function ($$v) {
                    _vm.selectedBuildings = $$v
                  },
                  expression: "selectedBuildings",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "issue-date-range" },
            [
              _c(
                "label",
                { staticClass: "emphasis ad-search-condition-label" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("workPermit.duration")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("HKLDateRange", {
                staticClass: "check-valid",
                attrs: {
                  required: true,
                  canPutTotop: false,
                  placeholders: [_vm.$t("dateFrom"), _vm.$t("dateTo")],
                  displayRange: _vm.displayRange,
                },
                model: {
                  value: _vm.duration,
                  callback: function ($$v) {
                    _vm.duration = $$v
                  },
                  expression: "duration",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }